import { render } from "./BaseHelp.vue?vue&type=template&id=66ccb7fe&scoped=true"
const script = {}

import "./BaseHelp.vue?vue&type=style&index=0&id=66ccb7fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ccb7fe"]])

export default __exports__